var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgJewelRingsWedding = function SvgJewelRingsWedding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.89 11.727a5.5 5.5 0 1 1-7.78 7.778 5.5 5.5 0 0 1 7.78-7.778",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.89 11.727a5.5 5.5 0 1 1-7.78 7.778 5.5 5.5 0 0 1 7.78-7.778",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.5 3.803c0 .438-.189.86-.526 1.173L12.763 7.04a.387.387 0 0 1-.527 0l-2.21-2.063A1.608 1.608 0 0 1 9.5 3.803v0c0-.932.755-1.687 1.687-1.687h2.626c.932 0 1.687.755 1.687 1.687v0Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgJewelRingsWedding;